// export const base_url_api = "https://3468-103-179-69-10.ap.ngrok.io/v1/main";
export const base_url_api =
  "https://kerjamolen.production.pangkalpinangkota.go.id/v1/main";
export const base_portal = "https://portal.production.pangkalpinangkota.go.id";

// FILE UPLOAD TEMP
export const upload_file = base_url_api + "/upload/file";
// Oengajuan
export const pengajuan = base_url_api + "/pengajuan";
// DOKUMEN
export const dokumen_api = base_url_api + "/dokumen";
// SETTINGS
export const setting_api = base_url_api + "/settings";
// GET ALAMAT
export const provinsi_api = base_portal + "/provinsi_v2";
export const kota_api = base_portal + "/kota_v2";
export const kecamatan_api = base_portal + "/kecamatan_v2";
export const kelurahan_api = base_portal + "/kelurahan_v2";
// GET ALL MITRA
export const all_media_api = base_url_api + "/perusahaan-media";
// GET DATE
export const date_api = base_url_api + "/tanggal-pengajuan";
// GET FAQ
export const faq_api = base_url_api + "/faqs";

// CHECK VALIDATION
export const check_nama_perusahaan_api =
  base_url_api + "/check-nama-perusahaan";
export const check_nama_media_api = base_url_api + "/check-nama-media";
export const check_email_api = base_url_api + "/check-email";
export const check_npwp_api = base_url_api + "/check-npwp";
export const check_no_akta_api = base_url_api + "/check-no-akta";
export const check_nib_api = base_url_api + "/check-nib";
